import React, { PropsWithChildren } from 'react';
import { Experiments, ExperimentVariantsValues } from 'app/types/optimizely';

export type VariationProps<E extends Experiments> = {
  variation?: ExperimentVariantsValues<E> | Array<ExperimentVariantsValues<E>>;
  default?: boolean;
};

export const ExperimentVariation = <E extends Experiments>({ children }: PropsWithChildren<VariationProps<E>>) => (
  <>{children}</>
);
